







































































import { Component, Vue } from 'vue-property-decorator'
import SigmaLeaderboardItem from '@/comps/LeaderboardItem.vue'
import LuciaGQLCore from '@/data/gql'

interface LeaderboardGQLUser {
  name: string,
  avatarUrl: string
}

interface LeaderboardGQLItem {
  score: number,
  user: LeaderboardGQLUser
}

interface LeaderboardGQLResponse {
  sigma: {
    entries: LeaderboardGQLItem[]
  }
}

interface LeaderboardWrapper {
  index: number,
  icon: string,
  user: LeaderboardGQLUser,
  value: number,
  level: number,
  title: string,
  nextRequired: number,
  nextPercent: number
}

const gql = new LuciaGQLCore()
const leaderboardIcons: string[] = [ 'trophy', 'gem', 'heart' ]

const levelers = {
  fish: 4.46,
  plant: 3.82,
  animal: 5.11,
  dessert: 3.35,
  drink: 2.71,
  meal: 2.74
} as any

const prefixes = {
  fish: [
    'Anchovy', 'Sardine', 'Carp', 'Tuna', 'Salmon',
    'Squid', 'Octopus', 'Shark', 'Blobfish', 'Whale'
  ],
  plant: [
    'Pickled', 'Jellied', 'Pressed', 'Ground', 'Juiced',
    'Chopped', 'Skinned', 'Infused', 'Boiled', 'Mashed'
  ],
  animal: [
    'Stalking', 'Swooping', 'Scavanging', 'Sneaking', 'Floating',
    'Gliding', 'Diving', 'Roaring', 'Gnashing', 'Shredding'
  ],
  dessert: [
    'Ice', 'Butter', 'Chocolate', 'Strawberry', 'Vanilla',
    'Apple', 'Rice', 'Lemon', 'Butterscotch', 'Meringue'
  ],
  drink: [
    'Cold', 'Refreshing', 'Creamy', 'Fizzy', 'Dry',
    'Sparkling', 'Tangy', 'Smokey', 'Fruity', 'Neat'
  ],
  meal: [
    'Tangled', 'Cream', 'Stinky', 'Crunchy', 'Warm',
    'Savory', 'Cheesy', 'Spicy', 'Garnished', 'Rare'
  ]
} as any

const suffixes = {
  fish: [
    'Angler', 'Baiter', 'Giller', 'Caster', 'Trawler',
    'Artisan', 'Waterbender', 'Reeler', 'Dredger', 'Mariner'
  ],
  plant: [
    'Potato', 'Tomato', 'Cucumber', 'Rose', 'Tulip',
    'Cactus', 'Cherry', 'Grape', 'Pepper', 'Plum'
  ],
  animal: [
    'Tarantula', 'Mamba', 'Piranha', 'Wolf', 'Komodo',
    'Crocodile', 'Orca', 'Grizzly', 'Lion', 'Hawk'
  ],
  dessert: [
    'Pie', 'Cream', 'Trifle', 'Pudding', 'Tiramisu',
    'Macaroon', 'Cookie', 'Cake', 'Frosting', 'Fudge'
  ],
  drink: [
    'Water', 'Lemonade', 'Milk', 'Soda', 'Wine',
    'Champagne', 'Mojito', 'Scotch', 'Gin', 'Vodka'
  ],
  meal: [
    'Spaghetti', 'Soup', 'Cheese', 'Casserole', 'Pilaf',
    'Pizza', 'Filet', 'Burger', 'Goulash', 'Steak'
  ]
} as any

function getTitle (level: number, variant: string): string {
  if (prefixes[variant] && suffixes[variant]) {
    const pfxs: string[] = prefixes[variant]
    const sfxs: string[] = suffixes[variant]
    const pfx: string = pfxs[Math.floor((level % 100) / pfxs.length)]
    const sfx: string = sfxs[(level % 100) % sfxs.length]
    return [pfx, sfx].join(' ')
  } else {
    return 'U̶n̵k̵n̴o̶w̸n̷ ̵G̷h̸o̷s̶t̶'
  }
}

function getNextRequired (level: number, variant: string): number {
  return Math.floor((level + 1) * (levelers[variant] ? levelers[variant] : 5))
}

function getPrevRequired (level: number, variant: string): number {
  return Math.floor((level !== 0 ? level - 1 : 0) * (levelers[variant] ? levelers[variant] : 5))
}

function getNextPercent (level: number, variant: string, score: number): number {
  const nextRequired = getNextRequired(level, variant)
  const prevRequired = getPrevRequired(level, variant)
  const diff = nextRequired - prevRequired
  const currDiff = nextRequired - score
  let perc = Math.floor(((diff - currDiff) / diff) * 100)
  if (perc === 100) {
    perc = 99
  }
  // console.log(`S: ${score}; L: ${level}; N: ${nextRequired}; P: ${prevRequired}; D: ${diff}; C: ${currDiff}; P: ${perc}`)
  return perc
}

function updateLeaderboard (ctx: SigmaLeaderboards) {
  const queryVariables = {
    leaderboardType: ctx.category.toUpperCase()
  }

  const qry = `query Leaderboards($leaderboardType: String!) {
    sigma {
      entries: leaderboard(type: $leaderboardType) {
        ...leaderboardItems
      }
    }
  }

  fragment leaderboardItems on LeaderboardEntry {
    score
    user {
      name
      avatarUrl
    }
  }`

  ctx.loading = true
  ctx.lastCategory = ctx.category
  if (ctx.boardCache[ctx.category]) {
    ctx.items = ctx.boardCache[ctx.category]
    ctx.loading = false
  } else {
    const newItems: LeaderboardWrapper[] = []
    const req: Promise<LeaderboardGQLResponse> = gql.request(qry, queryVariables)
    req.then((data: LeaderboardGQLResponse) => {
      let indexCounter = 0
      data.sigma.entries.forEach((elm: LeaderboardGQLItem) => {
        indexCounter += 1
        const leveler: number = levelers[ctx.category] ? levelers[ctx.category] : 1
        const level: number = Math.floor(elm.score / leveler)
        const title: string = getTitle(level, ctx.category)
        const newElm: LeaderboardWrapper = {
          index: indexCounter,
          icon: leaderboardIcons[indexCounter - 1] || 'hashtag',
          user: elm.user,
          value: elm.score,
          level: level,
          title: title,
          nextRequired: getNextRequired(level, ctx.category) + 1,
          nextPercent: getNextPercent(level, ctx.category, elm.score)
        }
        if (newElm.value > 0) {
          newItems.push(newElm)
        }
      })
      ctx.items = newItems
      ctx.loading = false
      ctx.errored = false
      ctx.boardCache[ctx.category] = ctx.items
    })
    req.catch(() => {
      ctx.loading = false
      ctx.errored = true
    })
  }
}

@Component({ components: { SigmaLeaderboardItem } })
export default class SigmaLeaderboards extends Vue {
  broad = 'professions'
  loading = true
  errored = false
  category = 'fish'
  lastCategory = 'currency'
  items: LeaderboardWrapper[] = []
  boardCache: any = {}

  mounted () {
    updateLeaderboard(this)
  }

  refreshLeaderboard (what: string) {
    if (this.lastCategory !== what) {
      this.category = what
      updateLeaderboard(this)
    }
  }

  switchBroad (what: string) {
    if (this.broad !== what) {
      this.broad = what
      this.refreshLeaderboard(this.broad === 'professions' ? 'fish' : 'dessert')
    }
  }
}
